const defaultState = {
  pages: [],
  currentPage: -1
}

const ADD_PAGE = 'jobs/ADD_PAGE'
const CHANGE_PAGE = 'jobs/CHANGE_PAGE'

export default (state = defaultState, {type, ...actionParams}) => {
  switch (type) {
    case ADD_PAGE:
      const {
        prevItems,
        nextItems,
        startkey
      } = actionParams

      return {
        ...state,
        startkey,
        pages: state.pages.concat([{
          start: prevItems.length,
          end: prevItems.length + nextItems.length
        }]),
        currentPage: state.currentPage + 1
      }

    case CHANGE_PAGE:
      return {
        ...state,
        currentPage: actionParams.page
      }
    default:
      return state
  }
}

export const addPage = (prevItems, nextItems, startkey) => ({
  prevItems,
  nextItems,
  startkey,
  type: ADD_PAGE
})

export const changePage = page => ({
  page,
  type: CHANGE_PAGE
})



// WEBPACK FOOTER //
// ./src/jobs/pagination-reducer.js